const mutations = {
    SET_ERROR_CASH_OUTPUTS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
